/*
 * Stock urgency — month label rotator.
 *
 * Every visit, compute today's calendar month and replace the labels on the
 * two rows so the "previous month" slot always shows last month and the
 * "current month" slot shows this month + today's day with an ordinal
 * suffix (e.g. "May 17th"). The status strings (e.g. "83% sold (14,110 out
 * of 17,000 ...)") are NOT touched, so the percentage never resets to 0%
 * across a month boundary — the cap value the merchant configured stays in
 * place.
 */
(function () {
  var roots = document.querySelectorAll(
    '.stock-urgency__rows[data-auto-rotate-months="true"]'
  );
  if (!roots.length) return;

  var MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  function ordinalSuffix(n) {
    var s = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    return s[(v - 20) % 10] || s[v] || s[0];
  }

  // Use the UK calendar date (Europe/London auto-handles BST/GMT) so every
  // visitor sees the same month/day as the merchant, regardless of where they
  // browse from. Falls back to the visitor's local date if Intl is unavailable.
  var now = new Date();
  var currentIdx = now.getMonth();
  var day = now.getDate();
  try {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/London',
      year: 'numeric', month: '2-digit', day: '2-digit'
    }).format(now);
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(parts);
    if (m) {
      currentIdx = parseInt(m[2], 10) - 1;
      day = parseInt(m[3], 10);
    }
  } catch (e) { /* Intl/timeZone unsupported — keep local date */ }
  var previousIdx = (currentIdx + 11) % 12; // wraps Jan → Dec
  var suffix = ordinalSuffix(day);

  roots.forEach(function (root) {
    var prev = root.querySelector('[data-row-slot="previous"] [data-row-label]');
    var curr = root.querySelector('[data-row-slot="current"] [data-row-label]');
    if (prev) prev.textContent = MONTHS[previousIdx];
    if (curr) {
      curr.textContent = MONTHS[currentIdx] + ' ' + day;
      var suffixEl = document.createElement('span');
      suffixEl.className = 'stock-urgency__row-label-suffix';
      suffixEl.textContent = suffix;
      curr.appendChild(suffixEl);
    }
  });
})();
